<template>
	<div v-if='loggedIn' class="login-group">
		<div class="profile-link profile-drop-menu">
			<!--<div class="name" v-if="$mq.isDesktop() && (!pageIsHome || !userIsSubscribed)">{{ $t("components.navigation.greeting") }}
				<span v-if="user.firstname" class="capitalize">{{user.firstname}}</span>
				<span v-else>{{user.email}}</span>
			</div>-->

			<div class="my-profile-wrapper">
				<router-link :to="{ name: user.subscription && !user.subscription.is_pending ? 'profile_orders' : 'profile_account'}" class='nav-item my-profile-btn' :class="{'partner-bennet': $root.source === 'bennet'}" >
					<!--{{ $t("components.navigation.your_profile") }}
					<i class="fa fa-caret-down" aria-hidden="true" v-if="$mq.isDesktop()"></i>-->
					<i class="fas fa-user"></i>
				</router-link>
			</div>

			<div class="dd-menu-login" v-if="$mq.isDesktop()">
				<div class="triangle-outer"></div>
				<div class="triangle-inner"></div>


				<template>
					<router-link :to="{name: 'profile_orders'}" class="nav-item">{{ $t("components.navigation.profile.orders") }}</router-link>
			
				</template>
				
				<router-link :to="{name: 'profile_account'}" class="nav-item">{{ $t("components.navigation.profile.my_account") }}</router-link>
				<template v-if="user.subscription && !user.subscription.is_pending">
					<!-- <router-link :to="{name: 'profile_next-order'}" class="nav-item" v-if="!user.subscription.is_suspended">{{ $t("components.navigation.profile.next_order") }}</router-link> -->
					<span v-if="$root.source !== 'enel'">
						<router-link :to="{name: 'profile_subscription'}" class="nav-item tag-partner">Abbonamento</router-link>
					</span>

					<router-link :to="{name: 'profile_shipment'}" class="nav-item" v-html="$t('components.navigation.profile.shipment')"></router-link>
				</template>


				<router-link v-if="user.subscription && !user.subscription.is_pending" :to="{name: 'profile_invite-friend'}" class="tag-partner nav-item">{{ $t("components.navigation.profile.invite_friend") }}</router-link>

				<router-link :to="{name: 'freshdesk'}" class="nav-item">Aiuto</router-link>
				<hr>

				<a href="#" @click="logout()" class="nav-item">{{ $t("auth.logout.logout") }}</a>
			</div>
		</div>
	</div>
</template>

<script type = "text/javascript" >
import { container } from '../services/container'

export default {

	computed: {
		user () {
			return this.$root.user
		},
		loggedIn () {
			return this.user && !this.user.email.includes('guest.quomi.it')
		},
		pageIsHome () {
			if (['dashboard'].indexOf(this.$route.name) >= 0) return true
		},

		userIsSubscribed () {
			return this.user && this.user.isSubscribed()
		}
	},

	methods: {
		logout () {
			container.get('services.oauth').logout().then(i => {
				window.location.href = '/'
			})

		}
	}
}

</script>

<style scoped>
	.profile-drop-menu {
		text-align: left;
	}

	.profile-drop-menu .dd-menu-login {
		display: none;
		padding: 15px 22px;
		position: absolute;
		z-index: 5;
		background: white;
		border: 1px solid #e8e8e8;
		border-radius: 3px;
		min-width: 240px;
		margin-top: 10px;
		
		right: 5%;
	}

	.profile-link .name {
		font-size: 13px;
	}

	.profile-drop-menu .dd-menu-login .triangle-outer,
	.profile-drop-menu .dd-menu-login .triangle-inner {
		right: 5%;
	}

	.dd-menu-login a {
		display: block;
		padding: 5px 0;
	}

	.triangle-outer,
	.triangle-inner  {
		position: absolute;
		top: -10px;
		right: 5%;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
	}

	.triangle-outer {
		border-bottom: 10px solid var(--quomi-ligthgrey-hover);
	}

	.triangle-inner {
		border-bottom: 11px solid white;
	}

	.profile-drop-menu:hover .dd-menu-login {
		display: block;
	}

	.dd-menu-login p {
		margin: 0 0 10px 0;
	}

	.profile-link {
		padding: 10px 0px 10px 0;
	}

	.login-group {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}

	.nav-item {
		display: block;
	}

	.nav-item:hover{
		color: var(--quomi-primary);
	}

	.my-profile-wrapper {
		display: flex;
		justify-content: flex-end;
	}

	.my-profile-btn,
	.my-profile-btn:hover,
	.my-profile-btn:focus {
		background-color: transparent;
		border-color: transparent;
		font-weight: bold;
		color: var(--quomi-primary);
		text-transform: uppercase;
		font-size: 21px;
		border: 1px solid var(--quomi-primary);
		padding: 1px 10px;
		border-radius: 5px;
	}

	.my-profile-btn .fa {
		padding-bottom: 1px;
	}

	.partner-bennet,
	.partner-bennet:hover {
		border: 1px solid white;
	}

@media (max-width: 1024px) {
	.profile-link {
		padding: 15px 0px 10px 0;
	}
}
</style>
